import React from "react";
import {
  Ban,
  Clock,
  DollarSign,
  LayoutGrid,
  RotateCcw,
  Trophy,
  XCircle,
} from "lucide-react";
import { JOINED_BET_FILTERS } from "../../utils/joinedBetsHelpers";

const FILTER_NAV = {
  all: { Icon: LayoutGrid, tone: "all" },
  pending: { Icon: Clock, tone: "pending" },
  won: { Icon: Trophy, tone: "won" },
  lost: { Icon: XCircle, tone: "lost" },
  voided: { Icon: Ban, tone: "voided" },
  paid: { Icon: DollarSign, tone: "paid" },
  refunded: { Icon: RotateCcw, tone: "refunded" },
};

const JoinedBetsStatusBar = ({
  activeFilter,
  onFilterChange,
  filterCounts,
}) => {
  return (
    <nav
      className="jb-panel-status"
      role="tablist"
      aria-label="Filter tickets by status"
    >
      {JOINED_BET_FILTERS.map((filter) => {
        const meta = FILTER_NAV[filter.id] || FILTER_NAV.all;
        const Icon = meta.Icon;
        const active = activeFilter === filter.id;
        const urgent =
          filter.id === "pending" && (filterCounts.pending ?? 0) > 0;
        return (
          <button
            key={filter.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`jb-panel-status-item jb-panel-status-item-${meta.tone} ${
              active ? "jb-panel-status-item-active" : ""
            } ${urgent && !active ? "jb-panel-status-item-urgent" : ""}`}
            onClick={() => onFilterChange(filter.id)}
          >
            <Icon size={12} strokeWidth={2.2} aria-hidden />
            <span>{filter.label}</span>
            <span className="jb-panel-status-count tabular-nums">
              {filterCounts[filter.id] ?? 0}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default JoinedBetsStatusBar;
